import React from 'react';
import PropTypes from 'prop-types';

import HorizontalFlow from '../../../../_layouts/HorizontalFlow';
import Badge from '../../../Badge';
import ActionMenuTitleComponent from './styles';

const ActionMenuTitle = (props) => {
  const { leftIcon, rightIcon, badgeText, children } = props;

  return (
    <ActionMenuTitleComponent>
      <HorizontalFlow spacing='0.5rem'>
        {leftIcon && <i className={`icon-${leftIcon}`} />}
        {children}
      </HorizontalFlow>

      <HorizontalFlow spacing='0.5rem'>
        {badgeText && <Badge text={badgeText} size='sm' />}
        {rightIcon && <i className={`icon-${rightIcon}`} />}
      </HorizontalFlow>
    </ActionMenuTitleComponent>
  );
};

ActionMenuTitle.defaultProps = {
  badgeText: null,
  leftIcon: null,
  rightIcon: null,
};

ActionMenuTitle.propTypes = {
  badgeText: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  leftIcon: PropTypes.string,
  rightIcon: PropTypes.string,
};

export default ActionMenuTitle;
